module.exports = __webpack_public_path__ + "media/newstyle/images/divulgacao2-4f9591abed01d488703852b362cc9745.png";